<i
  [inlineSVG]="icon"
  [removeSVGAttributes]="['style', 'fill']"
  [class.active]="active"
>
</i>
